import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-[var(--border-light)] px-4 py-12 text-[var(--foreground)] md:px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="inline-block">
            <img
              src="/dehleze-logo.png"
              alt="Dehleze Shopping"
              className="h-10 w-auto object-contain"
            />
          </Link> 
          <div className="flex gap-4 mt-4 flex-col">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-80 hover:opacity-100"
              style={{ color: '#0c0c0c' }}
              aria-label="Facebook"
            >
              Facebook
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-80 hover:opacity-100"
              style={{ color: '#0e0d0d' }}
              aria-label="Twitter"
            >
              Twitter
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-80 hover:opacity-100"
              style={{ color: '#0c0c0c' }}
              aria-label="Instagram"
            >
              Instagram
            </a>
          </div>
          
          
          
          
        </div>
        <div>
          <h3 className="font-semibold mb-3">Shop</h3>
          <ul className="space-y-2 text-sm text-[var(--text-muted)]">
            <li>
              <Link to="/" className="transition hover:text-[var(--primary-red)] hover:underline">
                Recently Viewed
              </Link>
            </li>
            <li>
              <Link to="/wishlist" className="transition hover:text-[var(--primary-red)] hover:underline">
                Wishlist
              </Link>
            </li>
            <li>
              <Link to="/shop" className="transition hover:text-[var(--primary-red)] hover:underline">
                Featured Products
              </Link>
            </li>
            <li>
              <Link to="/shop" className="transition hover:text-[var(--primary-red)] hover:underline">
                Categories
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="font-semibold mb-3">Information</h3>
          <ul className="space-y-2 text-sm text-[var(--text-muted)]">
                        
                                                <li>
              <Link to="/team" className="transition hover:text-[var(--primary-red)] hover:underline">
                Our Team
              </Link>
            </li>
            <li>
              <Link to="/contact" className="transition hover:text-[var(--primary-red)] hover:underline">
                Contact Us
              </Link>
            </li>
            <li>
              <Link to="/faqs" className="transition hover:text-[var(--primary-red)] hover:underline">
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/privacy" className="transition hover:text-[var(--primary-red)] hover:underline">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="font-semibold mb-3">Contact</h3>
          <ul className="space-y-2 text-sm text-[var(--text-muted)]">
            <li>
              <a href="tel:+923224540783" className="transition hover:text-[var(--primary-red)] hover:underline">
                Phone: +92 3019064986
              </a>
            </li>
            <li>
              <a href="mailto:dehleze.pk@gmail.com" className="transition hover:text-[var(--primary-red)] hover:underline">
                Address: 48 Main Gulberg
              </a>
            </li>
          </ul>
          <div className="mt-4 flex flex-row flex-wrap items-center gap-3">
            <img
              src="/jazz.png"
              alt="JazzCash"
              className="h-15 w-auto object-contain"
            />
            <img
              src="/easypaisa.png"
              alt="EasyPaisa"
              className="h-15 w-auto object-contain"
            />
          </div>
        </div>
      </div>
      <div className="mx-auto mt-8 border-t border-[var(--border-light)] pt-8 text-center text-sm text-[var(--text-muted)]">
        © {new Date().getFullYear()} Dehleze. All rights reserved.
      </div>
    </footer>
  );
}
